import DraggableParticipantInfoCard from "./draggableParticipantInfoCard.container";

export default DraggableParticipantInfoCard;
